// Product configuration mapping Persian names to backend product types
export const PRODUCT_CONFIG = {
  "شاخص سلامت گیاه": {
    productType: "NDVI",
    displayName: "شاخص سلامت گیاه",
    englishName: "Plant Health (NDVI)",
    unit: "شاخص",
    minValue: -1,
    maxValue: 1,
  },
  "شاخص میزان عملکرد محصول": {
    productType: "YIELD",
    displayName: "شاخص میزان عملکرد محصول",
    englishName: "Crop Yield Index",
    unit: "درصد",
    minValue: 0,
    maxValue: 100,
  },
  "شاخص درصد نیتروژن برگ": {
    productType: "LNC",
    displayName: "شاخص درصد نیتروژن برگ",
    englishName: "Leaf Nitrogen Content",
    unit: "درصد",
    minValue: 0,
    maxValue: 5,
  },
  "شاخص درصد رطوبت برگ": {
    productType: "LWC",
    displayName: "شاخص درصد رطوبت برگ",
    englishName: "Leaf Water Content",
    unit: "درصد",
    minValue: 0,
    maxValue: 100,
  },
  "شاخص تراکم پوشش گیاهی": {
    productType: "NDVI",
    displayName: "شاخص تراکم پوشش گیاهی",
    englishName: "NDVI",
    unit: "شاخص",
    minValue: -1,
    maxValue: 1,
  },
  "میزان ارتفاع گیاه": {
    productType: "CH",
    displayName: "میزان ارتفاع گیاه",
    englishName: "Canopy Height",
    unit: "متر",
    minValue: 0,
    maxValue: 10,
  },
  "شاخص تنش آبی": {
    productType: "CWSI",
    displayName: "شاخص تنش آبی",
    englishName: "Crop Water Stress Index",
    unit: "شاخص",
    minValue: 0,
    maxValue: 1,
  },
  "میزان تبخیر و تعرق واقعی": {
    productType: "ETa",
    displayName: "میزان تبخیر و تعرق واقعی",
    englishName: "Actual Evapotranspiration",
    unit: "میلی‌متر",
    minValue: 0,
    maxValue: 10,
  },
  "شاخص وضعیت آبیاری": {
    productType: "IWS",
    displayName: "شاخص وضعیت آبیاری",
    englishName: "Irrigation Water Status",
    unit: "شاخص",
    minValue: 0,
    maxValue: 1,
  },
  "شاخص رطوبت خاک": {
    productType: "SM",
    displayName: "شاخص رطوبت خاک",
    englishName: "Soil Moisture",
    unit: "درصد",
    minValue: 0,
    maxValue: 100,
  },
};

// Helper function to get product config by Persian name
export const getProductConfig = (persianName) => {
  return PRODUCT_CONFIG[persianName] || null;
};

// Helper function to get product type by Persian name
export const getProductType = (persianName) => {
  const config = PRODUCT_CONFIG[persianName];
  return config ? config.productType : null;
};

// Helper function to get all product types
export const getAllProductTypes = () => {
  return Object.values(PRODUCT_CONFIG).map((config) => config.productType);
};

// Helper function to get Persian name by product type
export const getPersianNameByType = (productType) => {
  const entry = Object.entries(PRODUCT_CONFIG).find(
    ([_, config]) => config.productType === productType
  );
  return entry ? entry[0] : null;
};

